import type { HttpClient, HttpContext, HttpEvent } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { UploadLane } from '../entities/upload-lane';
import { UPLOAD_HTTP_CLIENT } from './upload-http-client';

export interface UploadSendOptions {
  readonly headers?: Readonly<Record<string, string>>;
  readonly context?: HttpContext;
}

/** The one place that builds and sends an upload request. Retry, timeout and slots belong to the engine. */
@Injectable({ providedIn: 'root' })
export class UploadTransportService {
  private readonly injector = inject(Injector);

  // Resolved on the first upload: a service that merely holds the transport (and its specs) needs no upload chain.
  private get http(): HttpClient {
    return this.injector.get(UPLOAD_HTTP_CLIENT);
  }

  post<M, R>(lane: UploadLane<M, R>, file: File, meta: M, options: UploadSendOptions = {}): Observable<HttpEvent<unknown>> {
    const wire = lane.wire(file, meta);
    return this.http.request(wire.method, wire.url, {
      body: wire.body,
      params: wire.params,
      headers: options.headers as Record<string, string> | undefined,
      context: options.context,
      reportProgress: true,
      observe: 'events',
    });
  }
}
